module.exports = __webpack_public_path__ + "images/assets/efae99b9880b3a1476c9da13e57e35d3.svg";